import axios from './base'

const url = {
  uploadImage: '/api/images',
  searchImages: '/api/search/images'
}

export default {
  async uploadImage (formData) {
    return await axios.post(url.uploadImage, formData)
  },
  async searchImages ({ fuzzy, page, pageSize }) {
    return await axios.get(url.searchImages, {
      params: {
        fuzzy,
        page,
        pageSize
      }
    })
  }
}
